/**
 * Who gets the redesigned VAS orders list. VAS-only; staff, customers and suppliers keep their own
 * rules in staff/list and supplier/list.
 */

import { authRoles } from 'app/auth';

/** The only list the VAS team has: Orders (AllAppConfig `orders`). */
export const VAS_LIST_TYPES = ['order'];

function roleList(user) {
  const role = user?.role;
  if (Array.isArray(role)) return role.filter(Boolean);
  return role ? [role] : [];
}

/**
 * A VAS-only login: exactly one role, and it is vas manager, vas production or vas designer. A user
 * who holds a VAS role together with any other role keeps the page they had.
 */
export function isVasOnlyLogin(user) {
  const roles = roleList(user);
  return roles.length === 1 && (authRoles?.vasUsers || []).includes(roles[0]);
}

export function shouldUseVasList(user, type) {
  return VAS_LIST_TYPES.includes(type) && isVasOnlyLogin(user);
}
